import { call, put, takeLatest } from "redux-saga/effects";
import * as api from "../constants/api";

import {
  GET_PUBLIC_UPLOADS,
  SG_GET_PUBLIC_UPLOADS,
  FETCH_PUBLIC_UPLOAD,
  SG_FETCH_PUBLIC_UPLOAD,
  ADD_PUBLIC_UPLOAD,
  SG_ADD_PUBLIC_UPLOAD,
  EDIT_PUBLIC_UPLOAD,
  SG_EDIT_PUBLIC_UPLOAD,
  DELETE_PUBLIC_UPLOAD,
  SG_DELETE_PUBLIC_UPLOAD,
  GET_PUBLIC_UPLOADS_BY_CATEGORY,
  SG_GET_PUBLIC_UPLOADS_BY_CATEGORY,
  PUBLIC_UPLOADS_PENDING,
} from "constants/actions";
import { handleError } from "./ApiError";

// Get Public Uploads (List with filters)
function* getPublicUploadsSaga(action) {
  yield put({ type: PUBLIC_UPLOADS_PENDING });
  try {
    const res = yield call(api.GET_PUBLIC_UPLOADS, action.payload);
    yield put({ type: GET_PUBLIC_UPLOADS, payload: res.data });
  } catch (err) {
    yield call(handleError, err);
  }
}

// Fetch Single Public Upload
function* fetchPublicUploadSaga(action) {
  yield put({ type: PUBLIC_UPLOADS_PENDING });
  try {
    const res = yield call(api.FETCH_PUBLIC_UPLOAD, action.payload);
    yield put({ type: FETCH_PUBLIC_UPLOAD, payload: res.data });
  } catch (err) {
    yield call(handleError, err);
  }
}

// Add Public Upload
function* addPublicUploadSaga(action) {
  yield put({ type: PUBLIC_UPLOADS_PENDING });
  try {
    const res = yield call(api.ADD_PUBLIC_UPLOAD, action.payload);
    yield put({ type: ADD_PUBLIC_UPLOAD, payload: res.data });
    // Optionally refresh the list after adding
    yield put({ type: SG_GET_PUBLIC_UPLOADS, payload: {} });
  } catch (err) {
    yield call(handleError, err);
  }
}

// Edit Public Upload
function* editPublicUploadSaga(action) {
  yield put({ type: PUBLIC_UPLOADS_PENDING });
  try {
    const res = yield call(api.EDIT_PUBLIC_UPLOAD, action.payload);
    yield put({ type: EDIT_PUBLIC_UPLOAD, payload: res.data });
    // Optionally refresh the list after editing
    yield put({ type: SG_GET_PUBLIC_UPLOADS, payload: {} });
  } catch (err) {
    yield call(handleError, err);
  }
}

// Delete Public Upload
function* deletePublicUploadSaga(action) {
  yield put({ type: PUBLIC_UPLOADS_PENDING });
  try {
    yield call(api.DELETE_PUBLIC_UPLOAD, action.payload);
    yield put({ type: DELETE_PUBLIC_UPLOAD, payload: action.payload });
    // Optionally refresh the list after deleting
    yield put({ type: SG_GET_PUBLIC_UPLOADS, payload: {} });
  } catch (err) {
    yield call(handleError, err);
  }
}

// Get Public Uploads By Category (Custom Action)
function* getPublicUploadsByCategorySaga(action) {
  yield put({ type: PUBLIC_UPLOADS_PENDING });
  try {
    const res = yield call(api.GET_PUBLIC_UPLOADS_BY_CATEGORY, action.payload);
    yield put({ type: GET_PUBLIC_UPLOADS_BY_CATEGORY, payload: res.data });
  } catch (err) {
    yield call(handleError, err);
  }
}

export default function* publicUploadSaga() {
  yield takeLatest(SG_GET_PUBLIC_UPLOADS, getPublicUploadsSaga);
  yield takeLatest(SG_FETCH_PUBLIC_UPLOAD, fetchPublicUploadSaga);
  yield takeLatest(SG_ADD_PUBLIC_UPLOAD, addPublicUploadSaga);
  yield takeLatest(SG_EDIT_PUBLIC_UPLOAD, editPublicUploadSaga);
  yield takeLatest(SG_DELETE_PUBLIC_UPLOAD, deletePublicUploadSaga);
  yield takeLatest(SG_GET_PUBLIC_UPLOADS_BY_CATEGORY, getPublicUploadsByCategorySaga);
}
